import makeStyles from "@material-ui/core/styles/makeStyles";
import colors from "Styles/colors";

type Props = {
  pendingCount: number;
};

const useStyles = makeStyles(({ spacing }) => ({
  opacity: {
    opacity: ({ pendingCount }: Props) => (pendingCount > 0 ? 1 : 0.3),
  },
  link: {
    "&:hover": {
      textDecoration: "underline",
      textDecorationColor: colors.orange,
      cursor: "pointer",
    }
  },
  oval: {
    width: 16,
    height: 16,
    backgroundColor: ({ pendingCount }: Props) =>
      pendingCount > 0 ? colors.orange : colors.black,
    borderRadius: "50%",
    marginRight: 8,
  },
  text: {
    color: ({ pendingCount }: Props) =>
      pendingCount > 0 ? colors.orange : colors.black,
    fontWeight: 600,
    lineHeight: 1.33,
  },
}));

export default useStyles;
